import React, { Component } from "react";
import { withApollo } from "react-apollo";
import FooterShade from "./partials/footer";
import DiagonalLine from "./partials/diagonalLine";
import gql from "graphql-tag";
import Carousel from 'react-bootstrap/Carousel';
import Cookies from "universal-cookie";
const cookies = new Cookies();

//import moment from "moment";
//import gql from 'graphql-tag';

const BlogiHero = gql`
  query Slider {
    page(id: "cGFnZToy") {
      id
      slider {
        images {
          sourceUrl(size: LARGE)
        }
        quotes {
          quote
          quoteEn
          sticky
          url
        }
      }
    }
  }
`;

class HeroSlider extends Component {
  state = {
    dataq: [],
    selected: [],
    element: String
  };

  componentDidMount() {
    this.executeNotik();
  }

  executeNotik = async () => {
    const { client } = this.props;
    const props = await client.query({
      query: BlogiHero
    });
    //console.log(props);
    if (!props.data.page) {
      return <p>...</p>;
    }

    const array = props.data.page.slider.quotes;
    const element = array
      .sort(() => Math.random() - Math.random())
      .find(() => true);
    this.setState({ element });
    //console.log(element.quote);
    const imagez = props.data.page.slider.images;
    var shuffled = imagez.sort(function () {
      return 0.5 - Math.random();
    });

    var selected = shuffled.slice(0, 4);

    this.setState({ selected });
    
    const images = this.state.selected.map((prop, i) => {
      return (
        <Carousel.Item
          key={
            i
          }
          style={
            {
              backgroundImage: `url(${prop.sourceUrl})`
            }
          } >

          <div className="carousel-item-herotext-wrap">
            <div className="herotext">{cookies.get("lang") === "LV" ?
              this.state.element.quote:
              this.state.element.quoteEn
              }</div>
          </div>
          <FooterShade />
        </Carousel.Item>
      );
    });
    
    const dataq = (
      <div id="home">
        <Carousel
          id="carouselId_kom" controls={false} fade={true} interval={6000} pause={false}
        >
          {images}

        </Carousel>
        <DiagonalLine />
      </div>
    );
    this.setState({ dataq });
  };

  render() {
    const { dataq } = this.state;
    return <React.Fragment>{dataq}</React.Fragment>;
  }
}

export default withApollo(HeroSlider);
